module.exports = __webpack_public_path__ + "static/connectionYes-935e282fcda20ce08fd93dd7e896774e.png";